export type SupplierBillStatus =
  | 'DRAFT' | 'UNPAID' | 'PARTIALLY_PAID' | 'PAID' | 'BLOCKED' | 'REVERSED';

type ChipColor = 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';

// Single source of truth for status chip colors across the bill list and detail views.
export const SUPPLIER_BILL_STATUS_COLORS: Record<SupplierBillStatus, ChipColor> = {
  DRAFT: 'default',
  UNPAID: 'warning',
  PARTIALLY_PAID: 'info',
  PAID: 'success',
  BLOCKED: 'error',
  REVERSED: 'error',
};

export interface SupplierBillLine {
  id: string;
  supplierBillId: string;
  goodsReceiptLineId: string;
  purchaseOrderLineId: string;
  itemId: string;
  quantity: number;
  unitPrice: number;
  poUnitPrice?: number;
  lineTotal: number;
}

export interface SupplierBillLineCreateDTO {
  goodsReceiptLineId: string;
  quantity: number;
  unitPrice: number;
}

export interface BillReleaseBlock {
  justification: string;
}

export interface SupplierBill {
  id: string;
  billNumber: string;
  supplierInvoiceRef?: string;
  purchaseOrderId: string;
  supplierId: string;
  billDate: string;
  dueDate: string;
  status: SupplierBillStatus;
  subtotal: number;
  taxAmount: number;
  totalAmount: number;
  paidAmount: number;
  journalEntryId?: string;
  reversalJournalEntryId?: string;
  reversedById?: string;
  reversedDate?: string;
  blockReason?: string;
  releaseJustification?: string;
  releasedById?: string;
  releasedDate?: string;
  editedById?: string;
  editedDate?: string;
  editCount?: number;
  institutionId: string;
  lines: SupplierBillLine[];
}

export interface SupplierBillCreateDTO {
  purchaseOrderId: string;
  supplierInvoiceRef?: string;
  billDate: string;
  dueDate: string;
  taxAmount?: number;
  institutionId: string;
  lines: SupplierBillLineCreateDTO[];
}

export interface SupplierBillResponse {
  content: SupplierBill[];
  totalElements: number;
  totalPages: number;
  number: number;
  size: number;
}

export interface BillEditLineDTO {
  goodsReceiptLineId: string;
  unitPrice: number;
}

export interface BillEditDTO {
  billDate: string;
  dueDate: string;
  supplierInvoiceRef?: string;
  editReason: string;
  taxAmount?: number;
  lines: BillEditLineDTO[];
}

export interface SupplierBillEditLine {
  goodsReceiptLineId: string;
  prevUnitPrice: number;
  prevLineTotal: number;
}

export interface SupplierBillEdit {
  id: string;
  supplierBillId: string;
  editSeq: number;
  editedById: string;
  editedAt: string;
  editReason: string;
  reversalJournalEntryId?: string;
  newJournalEntryId?: string;
  prevBillDate: string;
  prevDueDate: string;
  prevSupplierInvoiceRef?: string;
  prevSubtotal: number;
  prevTaxAmount: number;
  prevTotalAmount: number;
  prevStatus: string;
  prevLines: SupplierBillEditLine[];
}
